export function buildCorporatePnlTemplatesByStrategyIdQueryV1(workspaceId: number, strategyId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Pnls.Queries.CorporatePnlTemplatesByStrategyIdQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
	}
}

export function buildCorporatePnlTemplateByIdQueryV1(workspaceId: number, strategyId: string, pnlId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Pnls.Queries.CorporatePnlTemplateByIdQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
		'PnlId': pnlId,
	}
}

export function buildPnlsPageQueryV1(workspaceId: number, strategyId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Pnls.Queries.PnlsPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
	}
}

export function buildDefaultPnlTemplateByIdQueryV1(workspaceId: number, strategyId: string, templateId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Pnls.Queries.DefaultPnlTemplateByIdQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
		'TemplateId': templateId,
	}
}

